import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { Flex, Segment, Loader } from 'nallian-shared-ui/lib/components';
import LegalDocs from './LegalDocs';
import CommunityTexts from './CommunityTexts';
import { WELCOME_TEXT_TYPE_ID, OVERVIEW_TEXT_TYPE_ID } from './constants';

const LegalAndTexts = () => {
  const communityFetch = useSelector(state => get(state, 'repository.community'));
  const communityTag = communityFetch?.value?.tag;
  const communityId = communityFetch?.value?.id;
  const defaultLanguageId = communityFetch?.value?.defaultLanguageId;

  return (
    <Segment basic>
      <Flex fluid direction="column" alignItems="center">
        {communityFetch?.pending && <Loader inline active />}
        {communityFetch?.value && (
          <>
            <CommunityTexts
              communityTag={communityTag}
              defaultLanguageId={defaultLanguageId}
              type={WELCOME_TEXT_TYPE_ID}
            />
            <CommunityTexts
              communityTag={communityTag}
              defaultLanguageId={defaultLanguageId}
              type={OVERVIEW_TEXT_TYPE_ID}
            />
            <LegalDocs communityTag={communityTag} communityId={communityId} />
          </>
        )}
      </Flex>
    </Segment>
  );
};

export default LegalAndTexts;
